var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearchQa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.55 10C4.55 7.10051 6.90051 4.75 9.8 4.75C12.6995 4.75 15.05 7.10051 15.05 10C15.05 11.122 14.698 12.1618 14.0985 13.015L12.294 11.4356C11.9823 11.1628 11.5085 11.1943 11.2357 11.506C10.9629 11.8177 10.9944 12.2915 11.3061 12.5643L13.0696 14.1079C12.1726 14.8228 11.0362 15.25 9.8 15.25C6.90051 15.25 4.55 12.8995 4.55 10ZM14.2125 15.1082C13.0293 16.1312 11.4869 16.75 9.8 16.75C6.07208 16.75 3.05 13.7279 3.05 10C3.05 6.27208 6.07208 3.25 9.8 3.25C13.5279 3.25 16.55 6.27208 16.55 10C16.55 11.5005 16.0604 12.8866 15.2323 14.0074L16.0262 14.7023C16.3379 14.9751 16.3694 15.4489 16.0966 15.7606C15.8238 16.0723 15.35 16.1038 15.0383 15.831L14.2125 15.1082Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchQa);
export default __webpack_public_path__ + "static/media/icon_search_qa.4dcc063517ee2c85ad768f14edc4e083.svg";
export { ForwardRef as ReactComponent };